import HierarchyView from './HierarchyView';

export default HierarchyView;
